export function replaceVariables(template: string, moreInfoStr: string, isBold = false) {
  const moreInfo = moreInfoStr ? JSON.parse(moreInfoStr) : null
  if (!template) return ''
  if (!moreInfo) return template

  const regex = /\[@:[a-f0-9-]+:([^\]]+)\]/g
  const newTemplate = template.replace(regex, `<span class=' text-white cursor-pointer'>@$1</span>`)

  return newTemplate.replace(/:([a-zA-Z0-9_]+)/g, (_, key) => {
    const value = moreInfo.hasOwnProperty(key) ? moreInfo[key] : `:${key}`
    return isBold ? `<span class='font-semibold text-white cursor-pointer'>${value}</span>` : value // Thay thế nếu tìm thấy, nếu không giữ nguyên
  })
}
